import "whatwg-fetch";
const env = process.env;

const getZones = params => {
  let filter = {
    where: {
      facility_id: params.facility_id
    }
  };

  if (params.zone_type_id && params.zone_type_id > 0) {
    filter["where"].zonetype_id = params.zone_type_id;
  }

  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/zones?access_token=${
      params.apitoken
    }&filter=${encodeURIComponent(JSON.stringify(filter))}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

export default {
  getZones
};
